(function ($, DGS) {
  'use strict';

  // Fix shift of page on orientation change devices for iOS
  window.addEventListener('orientationchange', function () {
    setTimeout(function () {
      window.scrollTo(window.scrollX, window.scrollY - 1);
    }, 500);
  });
})(jQuery, window.DGS);